import { CurrentStep, StepAction, StepState } from './types';

const findFirstFalseStep = (step: StepState): number | null => {
    const entries = Object.entries(step);
    const firstFalse = entries.find(([, value]) => !value);
    if (firstFalse) {
        return parseInt(firstFalse[0].replace('step', ''));
    }
    return null;
};

type ChangeStepState = {
    currentStep: CurrentStep
    stepStatus: StepState
    skippedSteps: number[]
}

export const changeStep = (
    state: ChangeStepState,
    action: StepAction
): ChangeStepState => {
    switch (action.type) {
        case 'nextStep': {
            const count = state.currentStep.currentStep;
            const steps = state.stepStatus;

            const currentStepKey = `step${count}` as keyof StepState;
            steps[currentStepKey] = true;

            const nextStepNumber = findFirstFalseStep(steps);
            return {
                currentStep: {
                    currentStep: nextStepNumber || count,
                },
                stepStatus: steps,
                skippedSteps: state.skippedSteps,
            };
        }
        case 'prevStep': {
            // 導線の分岐でスキップしたステップは戻る際にも飛ばす。
            // skippedStepsが空のときは従来通り count - 1 と完全に同一の挙動になる
            const skipped = state.skippedSteps ?? [];
            let count = state.currentStep.currentStep;
            do {
                count = Math.max(0, count - 1);
            } while (count > 0 && skipped.includes(count));

            return {
                ...state,
                currentStep: {
                    currentStep: count,
                },
            };
        }
        case 'setStepStatus': {
            return {
                ...state,
                stepStatus: {
                    ...state.stepStatus,
                    [action.key]: action.value,
                },
            };
        }
        case 'setSkippedSteps': {
            return {
                ...state,
                skippedSteps: action.steps,
            };
        }
        default:
            return state;
    }
};
